import { ApiError } from '../lib/api-client';

export function Loading({ label = 'Đang tải…' }: { label?: string }) {
  return (
    <p className="muted" role="status" aria-live="polite">
      {label}
    </p>
  );
}

/** Turns an ApiError into the message the contract says it means. */
export function ErrorState({ error }: { error: unknown }) {
  if (error instanceof ApiError) {
    if (error.isUnauthorized)
      return (
        <p className="error" role="alert">
          Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.
        </p>
      );
    if (error.isForbidden)
      return (
        <p className="error" role="alert">
          Bạn chưa có quyền truy cập nội dung này.
        </p>
      );
    return (
      <ul className="error" role="alert">
        {error.messages.map((message) => (
          <li key={message}>{message}</li>
        ))}
      </ul>
    );
  }
  return (
    <p className="error" role="alert">
      {error instanceof Error ? error.message : 'Đã có lỗi xảy ra.'}
    </p>
  );
}

export function Empty({ children }: { children: React.ReactNode }) {
  return <p className="muted">{children}</p>;
}
